import client from '../lib/http-client';
import { buildQuery } from '../lib/helper';

const endpoint = '/user';

export default {
	// Auth
	auth(creds, cb, errorCb) {
		client
			.post('/auth', creds)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Auth Dropshipper Only
	authDropshipper(creds, cb, errorCb) {
		client
			.post('/auth/dropshipper', creds)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Auth with OrderOnline Account
	authWithOO(creds, cb, errorCb) {
		client
			.post('/auth/oo', creds)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Update customize Product Column
	updateProductsColumns(creds, cb, errorCb) {
		const params = {
			product_columns: JSON.stringify(creds),
		}; client
			.put('/user/products_columns', params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Auth with Connection Token
	authWithConnectionToken(creds, cb, errorCb) {
		client
			.post('/auth/connection/token', creds)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Register
	register(body, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		const url = '/auth/register';
		client.post(url, body).then(responseHandler).catch(errorHandler);
	},

	// Register veriffication
	registerValidateCode(body, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		const url = '/auth/register/verification';
		client.post(url, body).then(responseHandler).catch(errorHandler);
	},

	// Logout
	logout(cb, errorCb) {
		const token = localStorage.getItem('token');
		const params = { token };
		client
			.post('/logout', params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Reset Password
	resetPassword(email, cb, errorCb) {
		const params = {
			email,
		};
		const url = `${endpoint}/password/reset`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Set Password
	setPassword(params, cb, errorCb) {
		const url = `${endpoint}/password/reset/create`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Validate Reset Password Code
	validateResetPasswordCode(params, cb, errorCb) {
		const url = `${endpoint}/password/reset/validate`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Get User Profile
	getProfile(cb, errorCb) {
		client
			.get(endpoint)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Update User Profile
	updateProfile(user, cb, errorCb) {
		client
			.put(endpoint, user)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},
	// Update User Email
	updateEmail(email, cb, errorCb) {
		const params = {
			email,
		};
		const url = `${endpoint}/update-email`;
		client
			.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},
	// Suspend User
	suspendStatus(id, cb, errorCb) {
		const params = id;
		const url = `${endpoint}/suspend`;
		client
			.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},
	// Suspend Product
	suspendProduct(params, cb, errorCb) {
		const url = `${endpoint}/product-status`;
		client
			.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},
	// Suspend Product Bulk
	suspendProductBulk(params, cb, errorCb) {
		const url = `${endpoint}/product-status/bulk`;
		client
			.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},
	// Update User Email With OTP Validation
	updateEmailWithOTP(params, cb, errorCb) {
		const url = `${endpoint}/update-email`;
		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},
	// Update User Phone Number
	updatePhoneNumber(phone, cb, errorCb) {
		const params = {
			phone,
		};
		const url = `${endpoint}/update-phone-number`;
		client
			.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update User Phone Number with OTP Validation
	updatePhoneNumberWithOTP(params, cb, errorCb) {
		const url = `${endpoint}/update-phone-number`;
		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Check Username
	checkUsername(username, cb, errorCb) {
		const params = {
			username,
		};
		const url = `${endpoint}/check_username`;
		client
			.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Change Password
	changePassword(currentPassword, newPassword, cb, errorCb) {
		const params = {
			current_password: currentPassword,
			new_password: newPassword,
		};
		const url = `${endpoint}/password`;
		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update Bank Accounts
	updateBankAccounts(bankAccounts, cb, errorCb) {
		const params = {
			bank_accounts: JSON.stringify(bankAccounts),
		};
		const url = `${endpoint}/bank_accounts`;
		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add Bank Account
	addBankAccountWithOtp(params, cb, errorCb) {
		const url = `${endpoint}/bank_account`;

		client
			.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update Identity Card
	updateIdentityCard(identity, cb, errorCb) {
		const params = {
			identity: JSON.stringify(identity),
		};
		const url = `${endpoint}/identity`;
		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update Identity Card by Admin
	updateIdentityCardByAdmin(params, cb, errorCb) {
		const url = `${endpoint}/identity/admin`;
		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update Store
	updateStore(store, cb, errorCb) {
		const params = {
			store: JSON.stringify(store),
		};
		const url = `${endpoint}/store`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update Username
	updateUsername(username, cb, errorCb) {
		const params = {
			username,
		};
		const url = `${endpoint}/username`;
		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update Auto Cancel Order
	updateAutoCancel(autoCancel, cb, errorCb) {
		const params = {
			auto_cancel_order: JSON.stringify(autoCancel),
		};
		const url = `${endpoint}/auto_cancel_order`;
		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},
	// Update Reseller
	updateReseller(reseller, cb, errorCb) {
		const params = {
			reseller: JSON.stringify(reseller),
		};
		const url = `${endpoint}/reseller`;
		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update Instant Payment
	updateInstantPayment(settings, cb, errorCb) {
		const params = {
			instant_payment: JSON.stringify(settings),
		};
		const url = `${endpoint}/instant_payment`;
		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update Auto Cancel Order
	updateTransactionalEmail(transactionalEmail, cb, errorCb) {
		const params = {
			transactional_email: JSON.stringify(transactionalEmail),
		};
		const url = `${endpoint}/transactional_email`;
		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update Pixel IDs
	udpatePixelIds(pixelIds, cb, errorCb) {
		const params = {
			pixel_ids: JSON.stringify(pixelIds),
		};
		const url = `${endpoint}/pixel_ids`;
		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update GTM IDs
	udpateGTMIds(gtmIds, cb, errorCb) {
		const params = {
			gtm_ids: JSON.stringify(gtmIds),
		};
		const url = `${endpoint}/gtm_ids`;
		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update TitkTok Pixel IDs
	udpateTikTokPixelIds(pixelIds, cb, errorCb) {
		const params = {
			pixel_ids: JSON.stringify(pixelIds),
		};
		const url = `${endpoint}/tiktok_pixel_ids`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Create User
	create(params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		const url = `${endpoint}`;
		client.post(url, params).then(responseHandler).catch(errorHandler);
	},

	// Update User - Admin Only
	update(id, params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const url = `${endpoint}/${id}`;
		client.put(url, params).then(responseHandler).catch(errorHandler);
	},

	// Get Users
	getUsers(params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		const query = buildQuery(params);
		const url = `${endpoint}/lists?${query}`;
		client.get(url).then(responseHandler).catch(errorHandler);
	},

	// Get Users Source Types
	getSourceTypes(cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		const url = `${endpoint}/source-type`;
		client.get(url).then(responseHandler).catch(errorHandler);
	},

	// Get Users MInimal
	getUsersMinimal(params, cb, errorCb) {
		const url = `${endpoint}/lists/minimal`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.get(url, { params }).then(responseHandler).catch(errorHandler);
	},

	// Bulk Delete
	bulkDelete(ids, cb, errorCb) {
		const params = {
			user_ids: JSON.stringify(ids),
			is_deleted: 1,
		};
		const url = `${endpoint}/is_deleted`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.put(url, params).then(responseHandler).catch(errorHandler);
	},

	// Bulk Change Status
	bulkChangeStatus(ids, status, cb, errorCb) {
		const params = {
			user_ids: JSON.stringify(ids),
			is_active: status,
		};
		const url = `${endpoint}/is_active`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.put(url, params).then(responseHandler).catch(errorHandler);
	},

	// Bulk Change Package
	bulkChangePackage(ids, packageName, cb, errorCb) {
		const params = {
			user_ids: JSON.stringify(ids),
			package: packageName,
		};
		const url = `${endpoint}/package`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.put(url, params).then(responseHandler).catch(errorHandler);
	},

	// Bulk Change Expired At
	bulkChangeExpiredDate(ids, expiredDate, cb, errorCb) {
		const params = {
			user_ids: JSON.stringify(ids),
			expired_date: expiredDate,
		};
		const url = `${endpoint}/expired_date`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.put(url, params).then(responseHandler).catch(errorHandler);
	},

	// Bulk Change Password
	bulkChangePassword(ids, password, cb, errorCb) {
		const params = {
			user_ids: JSON.stringify(ids),
			password,
		};
		const url = `${endpoint}/password/admin`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.put(url, params).then(responseHandler).catch(errorHandler);
	},

	// Update Payments
	updatePayments(payment, cb, errorCb) {
		const params = {
			payment_page: payment,
		};
		const url = `${endpoint}/payment_page`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.put(url, params).then(responseHandler).catch(errorHandler);
	},

	// Update Orders Columns
	udpateOrdersColumns(columns, cb, errorCb) {
		const params = { orders_columns: JSON.stringify(columns) };
		const url = `${endpoint}/orders_columns`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update Settings
	updateSettings(settings, cb, errorCb) {
		const params = {
			settings: JSON.stringify(settings),
		};
		const url = `${endpoint}/settings`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get User Addons
	getAddons(params, cb, errorCb) {
		const url = `${endpoint}/add_ons`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get User Addon's Config
	getAddonConfig(id, cb, errorCb) {
		const url = `${endpoint}/add_on/${id}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update User Addon's Config
	updateAddonConfig(params, id, cb, errorCb) {
		const url = `${endpoint}/add_on/${id}`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get User Addon's Status
	getAddonStatus(id, cb, errorCb) {
		const url = `${endpoint}/add_on/${id}`;
		const params = {
			fields: 'is_active',
		};
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get User Annual Report
	getAnnualReport(year, cb, errorCb) {
		const url = `${endpoint}/annual_report`;
		const params = {
			year,
		};
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update User Annual Report
	updateAnnualReport(year, images, cb, errorCb) {
		const url = `${endpoint}/annual_report/images?year=${year}`;
		const params = {
			images,
		};
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Activate Storefront E-Payment
	activateStorefrontEpayment(cb, errorCb) {
		const url = `${endpoint}/activate_storefront_epayment`;
		const params = {};
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get User Settings
	getUserSetting(params, cb, errorCb) {
		const url = `${endpoint}/setting`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// set User Setting
	setUserSetting(params, cb, errorCb) {
		const url = `${endpoint}/setting`;
		const settings = {
			settings: params,
		};
		client
			.post(url, settings)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// Connect
	connect(params, cb, errorCb) {
		const url = `${endpoint}/connection`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// remove Connection
	removeConnection(id, cb, errorCb) {
		const url = `${endpoint}/connection/${id}`;
		client
			.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// Connect
	connectionList(cb, errorCb) {
		const url = `${endpoint}/connection`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// Reconnect Account Connection
	reconnect(id, params, cb, errorCb) {
		const url = `${endpoint}/connection/${id}/reconnect`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Validate Password
	validatePassword(params, cb, errorCb) {
		const url = '/auth/validate-password';
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get User Stats by User ID
	getUserStats(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/stats?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Get Handling Fee User
	getListHandlingFee(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/handling-fee?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Handling Fee User
	exportHandlingFee(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/export/handling-fee?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};

// Update Store Status
export const updateStoreStatus = (params, cb, errorCb) => {
	const url = `${endpoint}/update_store_status`;
	const responseHandler = (response) => {
		if (cb) {
			cb(response.data);
		}
	};
	const errorHandler = (e) => {
		if (errorCb) {
			errorCb(e);
		}
	};
	client.put(url, params).then(responseHandler).catch(errorHandler);
};

export const getUserFeatCount = (feature, params, cb, errorCb) => {
	const url = `${endpoint}/count/${feature}`;

	const responseHandler = (response) => {
		if (cb) {
			cb(response.data);
		}
	};
	const errorHandler = (e) => {
		if (errorCb) {
			errorCb(e);
		}
	};

	client.get(url, { params })
		.then(responseHandler).catch(errorHandler);
};
